<template>
    <div class="vip-page pt-0px bg-#19100F! min-h-100vh">
        <div class="vip-header pt-20px flex justify-between px-20px absolute top-0 left-0 w-100% h-183px right-0 z-1"
            :style="{ backgroundImage: `url(${tabActive === 0 ? backgroundImage : backgroundImageUltra})` }">
            <div class="close w-24px h-24px " @click="handleClose">
                <img src="@/assets/images/vip/close.svg" alt="" class="w-full h-full"></img>
            </div>
            <div class=" flex text-16px color-#fff font-500">
                Member Center
            </div>
            <div></div>
            <div class="absolute bottom-20px right-20px w-88px h-88px">
                <img src="@/assets/images/vip/plus.webp" alt="" class="w-full h-full" v-if="tabActive === 0">
                <img src="@/assets/images/vip/ultra.webp" alt="" class="w-full h-full" v-if="tabActive === 1">
            </div>
            <div class="tab flex gap-5px">
                <div :class="tabActive === 1 ? 'ultra' : ''" @click="handleTabClick(1)">
                    Ultra
                </div>
                <div :class="tabActive === 0 ? 'plus' : ''" @click="handleTabClick(0)">
                    Plus
                </div>
            </div>
        </div>
        <vipU :vipBenefitList="vipBenefitList" v-if="tabActive === 1" :vipPerksUltra="vipPerks" ref="vipURef" />
        <!-- <vip :vipBenefitList="vipBenefitList" :vipPerks="vipPerks" v-if="tabActive === 2" ref="vipRef" /> -->
        <vipPlus :vipBenefitList="vipBenefitList" v-if="tabActive === 0" :vipPerksPlus="vipPerks" ref="vipPlusRef" />

    </div>
</template>

<script setup lang="ts">
import bridge from '@/utils/bridge'
import { computed, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { vipBenefitList } from './index'
import vipU from './com/vipU.vue'
import vipPlus from './com/vipPlus.vue'
import vip from './com/vip.vue'
import { useVipStore } from '@/stores/vip'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
const router = useRouter()
const vipStore = useVipStore()
const route = useRoute()
const tabActive = ref(1)
const vipPerks = computed(() => vipStore.vipPerks)
import backgroundImage from '@/assets/images/vip/bg-plus.webp'
import backgroundImageUltra from '@/assets/images/vip/bg-u.webp'
const userStore = useUserStore()
const vipRef = ref<InstanceType<typeof vip>>()
const vipPlusRef = ref<InstanceType<typeof vipPlus>>()
const vipURef = ref<InstanceType<typeof vipU>>()
const handleClose = () => {
    if (route.query.tab === 'chat') {
        router.back()
        return
    }
    if ([4, 5].includes(userStore.userInfo?.role)) {
        router.push({
            path: '/mine',
        })
    }
    if (tabActive.value === 1) {
        if (vipURef.value) {
            vipURef.value.handleShowRetentionPopup()
        }
    } else if (tabActive.value === 0) {
        if (vipPlusRef.value) {
            vipPlusRef.value.handleShowRetentionPopup()
        }
    } else {
        if (vipURef.value) {
            vipURef.value.handleShowRetentionPopup()
        }
    }
}


const handleTabClick = (index: number) => {
    tabActive.value = index
}
const handleRestore = () => {
    bridge.callApp('inAppRestore')
}
onMounted(async () => {
    vipStore.fetchVipPerks()
    const type = route.query.type as string
    if (type) {
        tabActive.value = type === 'u' ? 0 : type === 'p' ? 1 : 2
    }
})
</script>
<style scoped lang="scss">
.vip-header {
    .tab {
        position: absolute;
        bottom: 30px;
        left: 20px;
        border-radius: 15px;
        background-color: rgba(255, 255, 255, 0.1);

        div {
            padding: 4px 21px;
            border-radius: 15px;
            color: rgba(255, 255, 255, 0.7);
        }

        .plus {
            background: linear-gradient(90deg, #FFDFB3 0%, #EAB04E 100%);
            color: #854A0D;
            font-weight: 800;
        }

        .ultra {
            padding: 4px 21px;
            background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
            font-weight: 800;
            color: #490D73;
        }
    }
}

.sparkle {
    position: absolute;
    font-size: 12px;
    color: #FFD700;
    animation: sparkle-twinkle 2s ease-in-out infinite;
}

.sparkle-top-left {
    top: -5px;
    left: -5px;
}

.sparkle-bottom-right {
    bottom: -5px;
    right: -5px;
    animation-delay: 1s;
}

@keyframes sparkle-twinkle {

    0%,
    100% {
        opacity: 0.5;
        transform: scale(1);
    }

    50% {
        opacity: 1;
        transform: scale(1.2);
    }
}
</style>